import fetcher, { FleetGetListParams, FleetPaginated } from '../fetcher';

export type DMSSearchCustomerParam = FleetGetListParams &
	Partial<Record<'frmId' | 'fbdhId' | 'ccaId' | 'ccdhId', number>>;

export const dmsSearchCustomer = (body?: DMSSearchCustomerParam) => {
	return fetcher<
		FleetPaginated<{
			bmppGroupName: string;
			ccaName: null;
			ccdhName: null;
			customerId: string;
			customerName: string;
			fbdhName: null;
			frmName: null;
			processStatus: null;
		}>
	>({
		api: '/dms/search-customer',
		method: 'POST',
		body,
	});
};

export type DMSFile = {
	documentId: number;
	documentNo: string;
	fileId: number;
	fileName: string;
	fileUrl: string;
	downloadCount: number;
	lastDownloadBy: string;
	uploadDate: string;
	modifiedDate: string;
};

export type DMSDocument = {
	type: string;
	documentType: string;
	name: string;
	description?: string;
	files: DMSFile[];
};

export type DMSSection = {
	id: string;
	label: string;
	documents: DMSDocument[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	metadata?: Record<string, any>;
};

export type DMSSubCategory = {
	id: string;
	type: string;
	label: string;
	sections: DMSSection[];
};

export type DMSCategory = {
	id: string;
	type: string;
	label: string;
	fetchType: string;
	subCategories: DMSSubCategory[];
};

export const dmsGetCustomerDetail = (customerId: string) => {
	return fetcher<{
		customerId: string;
		customerName: string;
		bmppGroupName: string;
		ccaName: string;
		ccdhName: string;
		fbdhName: string;
		frmName: string;
		processStatus: string;
		categories: DMSCategory[];
	}>({
		api: '/dms/get-customer-detail',
		method: 'POST',
		body: {
			customerId,
		},
	});
};

export type DMSCategoryDetailResponse = {
	financingApprovalDocument: {
		details: Array<{
			mklNo: string;
			prospectId: string;
			customerName: string;
			customerId: string;
			bmppGroupId: string;
			bmppGroupName: string;
			documents: DMSDocument[];
		}>;
	} | null;
	covenantDocument: {
		details: Array<{
			mklNo: string;
			prospectId: string;
			customerName: string;
			customerId: string;
			bmppGroupId: string;
			bmppGroupName: string;
			spfList: Array<{
				mklNo: string;
				prospectId: string;
				customerName: string;
				customerId: string;
				bmppGroupId: string;
				bmppGroupName: string;
				spfNo: string;
				spfId: number;
				spfStatus: string;
				documents: DMSDocument[];
			}>;
		}>;
	} | null;
	financingDisbursementDocument: {
		mklList: Array<{
			mklNo: string;
			prospectId: string;
			customerName: string;
			customerId: string;
			bmppGroupId: string;
			bmppGroupName: string;
			mppList: Array<{
				mklNo: string;
				prospectId: string;
				customerName: string;
				customerId: string;
				bmppGroupId: string;
				bmppGroupName: string;
				mppId: number;
				mppNo: string;
				agreementNo: string | null;
				documents: DMSDocument[];
				disbursementList: Array<{
					disbursementId: number;
					disbursementNo: string;
					scheme: string;
					documents: DMSDocument[];
					purchaseOrderList: Array<{
						purchaseOrderId: number;
						purchaseOrderNo: string;
						documents: DMSDocument[];
						agreementList: Array<{
							agreementId: string;
							agreementNo: string;
							documents: DMSDocument[];
						}>;
					}>;
				}>;
			}>;
		}>;
	} | null;
};

export const dmsGetCategoryDetail = (
	customerId: string,
	categoryId: string,
) => {
	return fetcher<DMSCategoryDetailResponse>({
		api: '/dms/get-category-detail',
		method: 'POST',
		body: {
			customerId,
			categoryId,
		},
	});
};

export const dmsGetSignedUrl = (fileId: number) => {
	return fetcher<{
		signedUrl: string;
	}>({
		api: '/dms/get-signed-url',
		method: 'POST',
		body: {
			fileId,
		},
	});
};

export const dmsGetDownloadUrl = (fileId: number) => {
	return fetcher<{
		signedUrl: string;
	}>({
		api: '/dms/download-file',
		method: 'POST',
		body: {
			fileId,
		},
	});
};
